import { createSlice } from '@reduxjs/toolkit';
import { loginApi } from '../../../rtk-apis/auth/login';
import { multipleHospitalsApi } from '../../../rtk-apis/auth/multipleHospitals';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
  data: [],
  hospitals: [],
};

const multipleHospitalsSlice = createSlice({
  name: 'multipleHospitals',
  initialState,
  reducers: {
    clearMultipleHospitalsState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.data = [];
      state.hospitals = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(multipleHospitalsApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
        state.msg = 'LOADING...';
      })
      .addCase(multipleHospitalsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data || [];
        state.result = action?.payload || '';
        state.hospitals = action?.payload?.hospitals || [];
        state.msg = 'Login successfully.';
      })
      .addCase(multipleHospitalsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = '';
        state.data = [];

        const payload = action?.payload;
        if (typeof payload === 'string') {
          state.msg = payload;
          state.hospitals = [];
        } else if (typeof payload === 'object' && payload !== null) {
          state.msg = payload?.msg || 'Something went wrong!';
          state.hospitals = payload?.hospitals || [];
        } else {
          state.msg = 'Something went wrong!';
          state.hospitals = [];
        }
      });
  },
});

export default multipleHospitalsSlice.reducer;
export const { clearMultipleHospitalsState } = multipleHospitalsSlice.actions;
